<template>
  <div class="hello">
    <div
      style="width: 40px; border-bottom: 3px solid #0faa9d; margin-bottom: 15px"
    ></div>
    <table class="">
      <tr>
        <td>
          <b>DAY 1</b>
        </td>
        <td>07.00 – 08.00</td>
        <td>Berkumpul di Hasanudin Airport</td>
      </tr>
      <tr>
        <td></td>
        <td>08.00 – 09.00</td>
        <td>Check in & Boarding</td>
      </tr>
      <tr>
        <td></td>
        <td>09.25 – 10.50</td>
        <td>Penerbangan ke Denpasar</td>
      </tr>
      <tr>
        <td></td>
        <td>10.50 – 11.15</td>
        <td>Landing di Ngurah Rai Airport & Menuju Parkiran Bus</td>
      </tr>
      <tr>
        <td></td>
        <td>11.15 – 12.45</td>
        <td>Menuju restoran di Bedugul</td>
      </tr>
      <tr>
        <td></td>
        <td>12.45 – 13.30</td>
        <td>Makan siang & sholat ( Saras )</td>
      </tr>
      <tr>
        <td></td>
        <td>13.30 – 15.00</td>
        <td>Wisata Pura Ulundanu</td>
      </tr>
      <tr>
        <td></td>
        <td>15.00 – 18.00</td>
        <td>Perjalanan & wisata Tanah Lot</td>
      </tr>
      <tr>
        <td></td>
        <td>18.00 – 19.00</td>
        <td>Menuju restoran sunset road</td>
      </tr>
      <tr>
        <td></td>
        <td>19.00 – 20.00</td>
        <td>Makan malam di Grafika Sunset</td>
      </tr>
      <tr>
        <td></td>
        <td>20.00 – 21.30</td>
        <td>Belanja oleh-oleh di Krisna</td>
      </tr>
      <tr>
        <td></td>
        <td>21.30 – 22.00</td>
        <td>Menuju hotel Check in & istirahat</td>
      </tr>
    </table>

    <div
      style="width: 40px; border-bottom: 3px solid #0faa9d; margin-bottom: 15px"
    ></div>
    <table class="">
      <tr>
        <td>
          <b>DAY 2</b>
        </td>
        <td>06.00 – 08.00</td>
        <td>Sarapan & prepare check out</td>
      </tr>
      <tr>
        <td></td>
        <td>08.00 - 10.00</td>
        <td>
          Meninggalkan hotel & menuju parkir bis dilanjutkan wisata ke Pantai
          Kuta ( ganti transport )
        </td>
      </tr>
      <tr>
        <td></td>
        <td>10.30 – 11.00</td>
        <td>Menuju Bandara Ngurah Rai</td>
      </tr>
      <tr>
        <td></td>
        <td>11.00 – 13.30</td>
        <td>Makan siang dengan Box Check in & boarding</td>
      </tr>
      <tr>
        <td></td>
        <td>13.00 – 14.00</td>
        <td>Ngurah Rai Airport</td>
      </tr>
      <tr>
        <td></td>
        <td>14.00 – 15.40</td>
        <td>Penerbangan ke Makassar</td>
      </tr>
      <tr>
        <td></td>
        <td>15.40 – 16.00</td>
        <td>Tiba di Hasanudin Airport</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Jogja",
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table td span {
  border-top: 3px solid #0faa9d;
}
table td {
  font-size: 14px;
  vertical-align: top;
  padding-bottom: 10px;
}
table td:nth-child(1) {
  width: 50px;
}
table td:nth-child(2) {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Makassar.vue